"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSignupAvailabilityDto = instanceOfSignupAvailabilityDto;
exports.SignupAvailabilityDtoFromJSON = SignupAvailabilityDtoFromJSON;
exports.SignupAvailabilityDtoFromJSONTyped = SignupAvailabilityDtoFromJSONTyped;
exports.SignupAvailabilityDtoToJSON = SignupAvailabilityDtoToJSON;
exports.SignupAvailabilityDtoToJSONTyped = SignupAvailabilityDtoToJSONTyped;
/**
 * Check if a given object implements the SignupAvailabilityDto interface.
 */
function instanceOfSignupAvailabilityDto(value) {
    if (!('phone' in value) || value['phone'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function SignupAvailabilityDtoFromJSON(json) {
    return SignupAvailabilityDtoFromJSONTyped(json, false);
}
function SignupAvailabilityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'phone': json['phone'],
        'email': json['email'],
    };
}
function SignupAvailabilityDtoToJSON(json) {
    return SignupAvailabilityDtoToJSONTyped(json, false);
}
function SignupAvailabilityDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'phone': value['phone'],
        'email': value['email'],
    };
}
